import type { Component } from "vue";

export const routes = [
  {
    path: "/amazon/competitive/reporting",
    name: "amazon-competitive-reporting",
    component: (): Promise<Component> => import("./views/AmazonCompetitiveReporting.vue"),
    meta: {
      requiresAuth: true,
      requiredRoles: [],
      requiredGroups: ["adminUserAccess"],
    },
  },
];
